import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { MagasindetailComponent } from './magasindetail.component';

const routes: Routes = [
    {
        path: '',
        component: MagasindetailComponent
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class MagasindetailRoutingModule {}
